<section class="hero-carousel bg-blue-gradient-top-left" [appStoryblok]="_editable()">
    @if(component()) {
        @if(content() && content().length > 1) {
            <rds-carousel [showButtons]="true" aria-roledescription="carousel">
                @for(c of content(); track c._uid) {
                    <rds-carousel-item>
                        @if (components[c.component]) {
                            <ndc-dynamic [ndcDynamicComponent]="components[c.component]" [ndcDynamicInputs]="c">
                            </ndc-dynamic>
                        } @else {
                            <ndc-dynamic [ndcDynamicComponent]="components['notImplemented']" [ndcDynamicInputs]="c">
                            </ndc-dynamic>
                        }
                    </rds-carousel-item>
                }
            </rds-carousel>
        } @else {
            @if (components[c.component]) {
                <ndc-dynamic [ndcDynamicComponent]="components[c.component]" [ndcDynamicInputs]="c">
                </ndc-dynamic>
            } @else {
                <ndc-dynamic [ndcDynamicComponent]="components['notImplemented']" [ndcDynamicInputs]="c">
                </ndc-dynamic>
            }
        }
    }
</section>
